import { Divider } from '@mui/material';
import { Greeting } from 'components/Greeting';
import { Page } from 'components/Page/Page';
import * as React from 'react';
import { Region } from 'services/clients/regions';
import { Questions } from './Questions';

interface Props {
  region?: Region;
}

/**
 * Page and message shown when a user attempts to access a region they are not targed to have access to.
 */
export const FilteredRegion: React.FC<Props> = (props) => {
  const { region } = props;
  return (
    <Page className="p-16 pt-8">
      <div className="flex items-start flex-col space-y-4">
        <div className="space-y-4">
          <div className="space-y-4">
            <Greeting />
            <p>
              This feature cannot be accessed for {region ? region.name : 'the specified region'}.
            </p>
          </div>
          <Divider />
          <Questions />
        </div>
      </div>
    </Page>
  );
};
FilteredRegion.displayName = 'FilteredRegion';
